import { gql, FieldReadFunction, FieldFunctionOptions } from '@apollo/client';

import { getInLocalStorage } from '@trqk/utils';

export const GET_AUDIO_UPLOADS = gql`
    query getAudioUploads($localStorageKey: String!) {
        audioUploads(localStorageKey: $localStorageKey) @client {
            id
            assetUrl
            canceled
            duration
            error
            filename
            filesize
            statusMessage
            success
            trqkSongId
            uploadedAt
        }
    }
`;

const readAudioUploads: FieldReadFunction<UploadAudioFileOutput[]> = (
    existing: readonly UploadAudioFileOutput[] | undefined,
    options: FieldFunctionOptions,
) => {
    const { args } = options;

    if (!args?.localStorageKey) {
        return [] as UploadAudioFileOutput[];
    }

    return (
        getInLocalStorage(args.localStorageKey) ??
        ([] as UploadAudioFileOutput[])
    );
};

export const audioUploads = {
    read: readAudioUploads,
};
